import { render, staticRenderFns } from "./DragList.vue?vue&type=template&id=322a3915&scoped=true&"
import script from "./DragList.vue?vue&type=script&lang=ts&"
export * from "./DragList.vue?vue&type=script&lang=ts&"
import style0 from "./DragList.vue?vue&type=style&index=0&id=322a3915&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322a3915",
  null
  
)

export default component.exports